import PropTypes from 'prop-types';
// icons
import { Icon, addCollection } from '@iconify/react';
// @mui
import { Box } from '@mui/material';
// Generated by scripts/build-eva-subset.js (prebuild/prestart hook): only the
// eva icons referenced in src/, not the full 490-icon collection (~26KB gzip
// saved off the main chunk).
import evaIcons from '../utils/evaSubset.json';

// Pre-load the used eva icons locally so Iconify never hits the CDN
addCollection(evaIcons);

// ----------------------------------------------------------------------

Iconify.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  sx: PropTypes.object,
};

export default function Iconify({ icon, sx, ...other }) {
  return <Box component={Icon} icon={icon} sx={{ ...sx }} {...other} />;
}
